/**
 * Constantes pour le système d'autorisation
 */

export const ActionType = {
  CREATE: 'CREATE',
  READ: 'READ',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  BORROW: 'BORROW',
  RETURN: 'RETURN',
  CONSUME: 'CONSUME',
  REFILL: 'REFILL',
  RESERVE: 'RESERVE',
  VALIDATE_RESERVATION: 'VALIDATE_RESERVATION'
};

export const ModelType = {
  RESOURCE: 'RESOURCE',
  BORROWING: 'BORROWING',
  CONSUMPTION: 'CONSUMPTION',
  REFILL: 'REFILL',
  RESERVATION: 'RESERVATION',
  USER: 'USER',
  LOCATION: 'LOCATION',
  CATEGORY: 'CATEGORY',
  TAG: 'TAG'
};

// Mappings pour l'affichage
export const ActionLabels = {
  [ActionType.CREATE]: 'Créer',
  [ActionType.READ]: 'Voir',
  [ActionType.UPDATE]: 'Modifier',
  [ActionType.DELETE]: 'Supprimer',
  [ActionType.BORROW]: 'Emprunter',
  [ActionType.RETURN]: 'Retourner',
  [ActionType.CONSUME]: 'Consommer',
  [ActionType.REFILL]: 'Refaire le stock',
  [ActionType.RESERVE]: 'Réserver',
  [ActionType.VALIDATE_RESERVATION]: 'Valider une réservation'
};

export const ModelLabels = {
  [ModelType.RESOURCE]: 'Ressource',
  [ModelType.BORROWING]: 'Emprunt',
  [ModelType.CONSUMPTION]: 'Consommation',
  [ModelType.REFILL]: 'Refill',
  [ModelType.RESERVATION]: 'Réservation',
  [ModelType.USER]: 'Utilisateur',
  [ModelType.LOCATION]: 'Location',
  [ModelType.CATEGORY]: 'Catégorie',
  [ModelType.TAG]: 'Tag'
};
